"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityWarningsInWebAuthoring = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var shared_urls_1 = require("@tableau/shared-urls");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var DataQualityWarningsInWebAuthoringQueryGql_1 = require("../../queries/DataQualityWarningsInWebAuthoringQueryGql");
var renderQueryResult_1 = require("../renderQueryResult");
/**
 * Since the ttl is just used to mask flickering we decided to not make it configurable and just keep it relatively small
 * */
var cacheTimeToLiveInMillis = 60000;
function notEmpty(value) {
    return value !== null && value !== undefined;
}
function DataQualityWarningsInWebAuthoring(props) {
    var datasourceName = props.datasourceName, datasourceCaption = props.datasourceCaption, store = props.keyValueStore;
    var publishedConnectionsLineageEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).publishedConnectionsLineageEnabled;
    var setPlaceholderWarning = React.useCallback(function (warning) {
        var key = datasourceName + "-" + datasourceCaption;
        if (warning === null) {
            store.removeItem(key);
        }
        else {
            var cache = {
                warning: __assign({}, warning),
                expiry: new Date().getTime() + cacheTimeToLiveInMillis
            };
            store.setItem(key, JSON.stringify(cache));
        }
    }, [datasourceName, datasourceCaption, store]);
    var client = props.client, siteUrlName = props.siteUrlName, queryString = props.queryString, iconOnly = props.iconOnly;
    var _a = React.useMemo(function () {
        var siteUrls = new shared_urls_1.SiteUrls({ siteUrlName: siteUrlName, queryString: queryString });
        var featureFlags = data_catalog_shared_1.defaultFeatureFlagsWithOverrides({
            dqcertificationVisualDesignEnabled: true,
            markupEditingEnabled: true,
        });
        return [
            {
                renderData: renderWarnings(siteUrls, iconOnly, setPlaceholderWarning),
                renderLoading: renderCachedWarningsIfPresent(siteUrls, iconOnly, datasourceName, datasourceCaption, store),
                renderDataWithError: renderWarnings(siteUrls, iconOnly, setPlaceholderWarning),
                renderError: function (_) {
                    setPlaceholderWarning(null);
                    return null;
                },
                renderNoData: function () {
                    setPlaceholderWarning(null);
                    return null;
                }
            },
            siteUrls,
            featureFlags
        ];
    }, [siteUrlName, queryString, iconOnly, datasourceName, datasourceCaption, setPlaceholderWarning, store]), renderers = _a[0], siteUrls = _a[1], featureFlags = _a[2];
    var workbookIds = props.workbookIds, flowIds = props.flowIds, publishedDatasourceIds = props.publishedDatasourceIds, databaseServerIds = props.databaseServerIds, databaseTableIds = props.databaseTableIds;
    var warningStatusPropsWithExpiry = store.tryGetAndParse(datasourceName + "-" + datasourceCaption);
    var now = new Date().getTime();
    if (warningStatusPropsWithExpiry !== null && warningStatusPropsWithExpiry.expiry > now) {
        return (iconOnly
            ? React.createElement(data_catalog_shared_1.WarningStatusIcon, __assign({}, warningStatusPropsWithExpiry.warning, { urls: siteUrls }))
            : React.createElement(data_catalog_shared_1.WarningStatusChip, __assign({}, warningStatusPropsWithExpiry.warning, { urls: siteUrls })));
    }
    var variables = {
        workbookIds: __spreadArray([], workbookIds.filter(notEmpty)),
        flowIds: __spreadArray([], flowIds.filter(notEmpty)),
        publishedDatasourceIds: __spreadArray([], publishedDatasourceIds.filter(notEmpty)),
        databaseServerIds: __spreadArray([], databaseServerIds.filter(notEmpty)),
        databaseTableIds: __spreadArray([], databaseTableIds.filter(notEmpty)),
        publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled
    };
    return (React.createElement(data_catalog_shared_1.VizClientDataCatalogProvider, { client: client, siteUrls: siteUrls, featureFlags: featureFlags },
        React.createElement(react_apollo_1.Query, { query: DataQualityWarningsInWebAuthoringQueryGql_1.DataQualityWarningsInWebAuthoringQueryGql, variables: variables }, function (result) { return renderQueryResult_1.renderQueryResult(result, renderers); })));
}
exports.DataQualityWarningsInWebAuthoring = DataQualityWarningsInWebAuthoring;
function renderCachedWarningsIfPresent(urls, iconOnly, datasourceName, datasourceCaption, store) {
    return function () {
        var warningStatusProps = store.tryGetAndParse(datasourceName + "-" + datasourceCaption);
        if (!warningStatusProps) {
            return React.createElement(React.Fragment, null);
        }
        return (iconOnly
            ? React.createElement(data_catalog_shared_1.WarningStatusIcon, __assign({}, warningStatusProps.warning, { urls: urls }))
            : React.createElement(data_catalog_shared_1.WarningStatusChip, __assign({}, warningStatusProps.warning, { urls: urls })));
    };
}
function renderWarnings(urls, iconOnly, setPlaceholderWarning) {
    return function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (!data) {
            return null;
        }
        var wb = (_b = (_a = data.workbooksConnection) === null || _a === void 0 ? void 0 : _a.nodes) !== null && _b !== void 0 ? _b : [];
        var fl = (_d = (_c = data.flowsConnection) === null || _c === void 0 ? void 0 : _c.nodes) !== null && _d !== void 0 ? _d : [];
        var ds = (_f = (_e = data.publishedDatasourcesConnection) === null || _e === void 0 ? void 0 : _e.nodes) !== null && _f !== void 0 ? _f : [];
        var db = (_h = (_g = data.databaseServersConnection) === null || _g === void 0 ? void 0 : _g.nodes) !== null && _h !== void 0 ? _h : [];
        var tb = (_k = (_j = data.databaseTablesConnection) === null || _j === void 0 ? void 0 : _j.nodes) !== null && _k !== void 0 ? _k : [];
        if (wb.length === 0 && fl.length === 0 && ds.length === 0 && db.length === 0 && tb.length === 0) {
            return null;
        }
        var upstreamWarnings = uniqueWarnings(wb, fl, ds, db, tb);
        if (upstreamWarnings.length === 0) {
            setPlaceholderWarning(null);
            return null;
        }
        var warningStatusProps = {
            subjectArea: null,
            kind: 'graph',
            anchoredAsset: null,
            anchoredWarnings: [],
            iconOnly: iconOnly,
            urls: urls,
            upstreamWarnings: upstreamWarnings,
        };
        setPlaceholderWarning(warningStatusProps);
        return (iconOnly
            ? React.createElement(data_catalog_shared_1.WarningStatusIcon, __assign({}, warningStatusProps))
            : React.createElement(data_catalog_shared_1.WarningStatusChip, __assign({}, warningStatusProps)));
    };
}
function uniqueWarnings(wb, fl, ds, db, tb) {
    var seen = new Set();
    var result = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], flattenWorkbooks(wb)), flattenWarnings(fl)), flattenWarnings(ds)), flattenWarnings(db)), flattenWarnings(tb));
    return result.filter(function (it) {
        if (seen.has(it.vizportalId)) {
            return false;
        }
        else {
            seen.add(it.vizportalId);
            return true;
        }
    }).sort(function (it) { return it.isSevere ? -1 : 1; });
}
function flattenWorkbooks(items) {
    if (items.length === 0) {
        return [];
    }
    return flattenWarnings(items.map(function (it) { return __assign(__assign({}, it), { dataQualityWarnings: [] }); }));
}
function flattenWarnings(items) {
    if (items.length === 0) {
        return [];
    }
    var nestedWarnings = items
        .map(function (it) {
        var _a, _b;
        return __spreadArray(__spreadArray([], (it.dataQualityWarnings ? it.dataQualityWarnings : [])), ((_b = (_a = it.upstreamDataQualityWarningsConnection) === null || _a === void 0 ? void 0 : _a.nodes) !== null && _b !== void 0 ? _b : []));
    });
    return nestedWarnings.reduce(function (a, b) { return a.concat(b); }, []);
}
//# sourceMappingURL=DataQualityWarningsInWebAuthoring.js.map